import { render, staticRenderFns } from "./labelSelect.vue?vue&type=template&id=06e73ac5&scoped=true&"
import script from "./labelSelect.vue?vue&type=script&lang=js&"
export * from "./labelSelect.vue?vue&type=script&lang=js&"
import style0 from "./labelSelect.vue?vue&type=style&index=0&id=06e73ac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e73ac5",
  null
  
)

export default component.exports